import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import Icon from './Icon'

const AutoLinkHeader = ({ id, as: Component, children, ...rest }) => {
  const theme = useTheme()

  return (
    <Component
      id={id}
      className={
        Component !== 'h5' ? 'AutoLinkHeader' : null
      } /* @NOTE We don't go that deep with our headings for scrollspy */
      css={{
        position: 'relative',

        '&:hover, &:focus': {
          '.AutoLinkHeader__Link': {
            opacity: 1,
            pointerEvents: 'auto',
          },
        },
      }}
      {...rest}
    >
      <a
        href={`#${id}`}
        css={{
          pointerEvents: 'none',
          position: 'absolute',
          opacity: 0,
          top: '50%',
          left: 0,
          transform: 'translate(-100%, -50%)',
          paddingRight: theme.space.small,
          transition: `opacity ${theme.timing.base} ${theme.transition.bounce}`,
        }}
        className="AutoLinkHeader__Link"
      >
        <Icon
          icon="anchor"
          css={{
            ...theme.text.small,
            color: theme.fontColor.base,

            '.u-contrast &': {
              color: theme.contrast.base,
            },
          }}
        />
      </a>
      {children}
    </Component>
  )
}

AutoLinkHeader.propTypes = {
  id: PropTypes.string.isRequired,
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  children: PropTypes.node.isRequired,
}

export default AutoLinkHeader
